import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { reduxForm } from 'redux-form';
import Paper from '@material-ui/core/Paper';
import classnames from 'classnames';

import ORTypography from 'components/ORTypography/ORTypography';

const propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

const useStyles = makeStyles((theme) => ({
  container: {
    padding: `${theme.spacing(1)}px ${theme.spacing(3)}px`,
    border: `2px solid ${theme.customColors.mediumGrey}`,
    cursor: 'pointer',
    backgroundColor: (props) =>
      props.isSelected ? theme.customColors.teal : theme.customColors.white,
    color: (props) => (props.isSelected ? theme.customColors.white : theme.customColors.black),
  },
  title: {
    textAlign: 'center',
    display: 'inline-block',
  },
  description: {
    '& > h6': {
      display: 'none',
    },
    '& > ul': {
      textAlign: 'center',
      listStyle: 'none',
      padding: 0,
      fontSize: '.8571rem',
    },
  },
  betaText: {
    float: 'right',
    display: 'inline-block',
    color: theme.palette.primary.main,
    fontStyle: 'italic',
    fontSize: '0.7857142857rem',
    fontWeight: 'bold',
  },
}));

export function UnstyledFlavorSelector({ title, description, isSelected, onClick, className }) {
  const classes = useStyles({ isSelected });

  return (
    <Paper className={classnames(classes.container, className)} onClick={onClick} elevation={0}>
      <ORTypography className={classes.title} variant="h6">
        {title}
      </ORTypography>
      {title === 'Sharded' && <ORTypography className={classes.betaText}>BETA</ORTypography>}
      {/* eslint-disable-next-line react/no-danger */}
      <div className={classes.description} dangerouslySetInnerHTML={{ __html: description }} />
    </Paper>
  );
}

UnstyledFlavorSelector.propTypes = propTypes;
UnstyledFlavorSelector.defaultProps = defaultProps;

export default reduxForm({
  form: 'create',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(UnstyledFlavorSelector);
